import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useDebouncedCallback } from 'use-debounce';
import { IconButton } from '@atlaskit/button/new';
import ChevronLeftLargeIcon from '@atlaskit/icon/utility/migration/chevron-left--chevron-left-large';
import ChevronRightLargeIcon from '@atlaskit/icon/utility/migration/chevron-right--chevron-right-large';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { messages } from './messages';
var OFFSET = 250;
var isScrollAtLeft = function isScrollAtLeft(elem) {
  return (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) === 0;
};
var isScrollAtRight = function isScrollAtRight(elem) {
  return elem ?
  // https://stackoverflow.com/questions/3898130/check-if-a-user-has-scrolled-to-the-bottom-not-just-the-window-but-any-element
  Math.abs((elem === null || elem === void 0 ? void 0 : elem.scrollWidth) - (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) - (elem === null || elem === void 0 ? void 0 : elem.clientWidth)) <= 1 : false;
};
var containerStyle = xcss({
  display: 'flex',
  position: 'relative',
  alignItems: 'center'
});
var hoverButtonStyle = xcss({
  position: 'absolute',
  zIndex: 'layer',
  cursor: 'pointer',
  height: '100%',
  display: 'flex',
  alignItems: 'center'
});
var leftStyle = xcss({
  background: "linear-gradient(90deg, ".concat("var(--ds-surface-overlay, #FFFFFF)", " 0%, ", "var(--ds-surface-overlay, #FFFFFF)", " 80%, rgba(255,0,0,0) 100%)"),
  left: '0',
  ':hover': {
    paddingRight: 'space.100'
  }
});
var rightStyle = xcss({
  background: "linear-gradient(270deg, ".concat("var(--ds-surface-overlay, #FFFFFF)", " 0%, ", "var(--ds-surface-overlay, #FFFFFF)", " 80%, rgba(255,0,0,0) 100%)"),
  right: '0',
  ':hover': {
    paddingLeft: 'space.100'
  }
});
var scrollContainerStyle = xcss({
  minWidth: 'space.0',
  display: 'flex',
  overflowX: 'auto',
  overflowY: 'hidden',
  gap: 'space.100'
});
export var HorizontalScrollContainer = function HorizontalScrollContainer(_ref) {
  var children = _ref.children;
  var ref = useRef(null);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldHideLeft = _useState2[0],
    setShouldHideLeft = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldHideRight = _useState4[0],
    setShouldHideRight = _useState4[1];
  var _useDebouncedCallback = useDebouncedCallback(function () {
      setShouldHideLeft(isScrollAtLeft(ref.current));
      setShouldHideRight(isScrollAtRight(ref.current));
    }, 10),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
    onScroll = _useDebouncedCallback2[0];
  useEffect(function () {
    setShouldHideLeft(isScrollAtLeft(ref.current));
    setShouldHideRight(isScrollAtRight(ref.current));
  }, []);
  return /*#__PURE__*/React.createElement(Inline, {
    xcss: containerStyle
  }, !shouldHideLeft && /*#__PURE__*/React.createElement(Box, {
    xcss: [hoverButtonStyle, leftStyle]
  }, /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ChevronLeftLargeIcon,
    isTooltipDisabled: true,
    label: formatMessage(messages.scrollLeft),
    onClick: function onClick() {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.scrollBy({
        top: 0,
        left: -OFFSET,
        behavior: 'smooth'
      });
    }
  })), /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    xcss: scrollContainerStyle,
    onScroll: onScroll
  }, children), !shouldHideRight && /*#__PURE__*/React.createElement(Box, {
    xcss: [hoverButtonStyle, rightStyle]
  }, /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ChevronRightLargeIcon,
    isTooltipDisabled: true,
    label: formatMessage(messages.scrollRight),
    onClick: function onClick() {
      var _ref$current2;
      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.scrollBy({
        top: 0,
        left: OFFSET,
        behavior: 'smooth'
      });
    }
  })));
};